import { render, staticRenderFns } from "./PayPeriod.vue?vue&type=template&id=12b67ec4&"
import script from "./PayPeriod.vue?vue&type=script&lang=js&"
export * from "./PayPeriod.vue?vue&type=script&lang=js&"
import style0 from "./PayPeriod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports